import { useCreateEntity } from '@abaninja/util-store';

import { reactivateAccount } from '../accounts';

export const useReactivateAccountStore = () => useCreateEntity(reactivateAccount);
